import { Button, Typography, useTheme } from '@themenu/design-system'
import React, { type ReactElement } from 'react'
import { clearSavedTokens } from '../services/authentication'
import { environmentVariables } from '../utils/environmentVariables'
import { redirectToUrl } from '../utils/location'

export const LoginSuccessRoute = (): ReactElement => {
  const theme = useTheme()

  const out = () => {
    clearSavedTokens()
    redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin`)
  }

  return (
    <main
      className={
        'flex h-dvh flex-col items-center justify-center gap-16 bg-background-default p-24 dark:bg-background-default-dark'
      }
    >
      <Typography variant="body">Login success</Typography>
      <Button onClick={out}>Logout</Button>
    </main>
  )
}
